import { Component } from '@angular/core';
import { ComingSoonPage } from '../../../../../shared/ui/coming-soon-page/coming-soon-page';

@Component({
  selector: 'app-edit-offer',
  imports: [ComingSoonPage],
  templateUrl: './edit-offer.html',
  styleUrl: './edit-offer.scss',
})
export class EditOffer {}
